import React, { useState } from 'react';
import MultiSelectCheckbox from '../../../../shared/common/MultiSelectCheckbox';
import MultiCountrySelector from '../../../../shared/common/MultiCountrySelector';
import {
  formatSelectedValues,
  normalizeDisplayArray,
} from "../helpers/utils";
import {
  designClasses,
} from "../../../../shared/styles/designTokens";
import MultiCountryStateCitySelector from '../../../../shared/common/MultiCountryStateCitySelector';
import FullWidthHobbiesGrid from '../../../../shared/components/FullWidthHobbiesGrid';
import MultiSelectField from '../../../../shared/forms/MultiSelectField';
import useApiData from '../../../../hooks/useApiData';


const GeographicPreferences = ({
  mode = 'view',
  profileData = {},
  formData = {},
  setFormData = () => {},
  editModeActive,
  professionOptions = [],
  professionInput = '',
  setProfessionInput = () => {},
  professionLoading = false,
   dietOptions = []
}) => {
  const { searchPlaces } = useApiData() || {};
  const [nativeInput, setNativeInput] = useState("");
  const [nativeOptions, setNativeOptions] = useState([]);
  const [nativeLoading, setNativeLoading] = useState(false);

  const handleMultiChange = (name, values) => {
    setFormData((prev) => ({
      ...prev,
      [name]: values.map((v) =>
        typeof v === "object" && v !== null
          ? v
          : { label: v, value: v }
      ),
    }));
  };

   const handleHobbyChange = (e) => {
     const { name, value } = e.target;

     setFormData((prev) => ({
       ...prev,
       [name]: Array.isArray(value) ? value : [],
     }));
   };


  const searchNativePlaces = async (text) => {
    setNativeInput(text);
    if (!text || text.trim().length < 2) {
      setNativeOptions([]);
      return;
    }
    setNativeLoading(true);
    try {
      const result = await searchPlaces(text);
      setNativeOptions(Array.isArray(result) ? result : []);
    } finally {
      setNativeLoading(false);
    }
  };

  if (mode === 'view') {
    return (
      <section>
        
        <div className="space-y-6">
          {[
            { label: "Preferred Native Places", field: "preferred_native_origins" },
{ label: "Preferred Countries", field: "preferred_countries" },
{ label: "Preferred Locations", field: "preferred_cities" },
{ label: "Preferred Profession", field: "preferred_professions" },
{ label: "Preferred Hobbies", field: "preferred_hobbies" },
          ].map(({ label, field }) => (
            <div key={field} className={`rounded-lg p-4 ${designClasses.surfaceMuted}`}>
              <h4 className={`mb-2 font-semibold ${designClasses.textPrimary}`}>{label}</h4>
              <p className={designClasses.textSecondary}>{normalizeDisplayArray(profileData[field], field)}</p>

            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section>
      <h2
  className={designClasses.formSectionHeading}
>
  Geographic & Lifestyle Expectations
</h2>
      <div className="space-y-6">

<MultiSelectField
  label="Preferred Native Places"
  options={nativeOptions}
  value={
    formatSelectedValues(formData, 'preferredNativeOrigins').length
      ? formatSelectedValues(formData, 'preferredNativeOrigins')
      : formatSelectedValues(profileData, 'preferred_native_origins')
  }
  searchValue={nativeInput}
  loading={nativeLoading}
  onSearchChange={searchNativePlaces}
  onChange={(values) => handleMultiChange('preferredNativeOrigins', values)}
  placeholder="Type to search native place"
/>
<MultiCountrySelector
  label="Preferred Countries"
  name="preferredCountries"
  selectedValues={
    formatSelectedValues(formData, 'preferredCountries').length
      ? formatSelectedValues(formData, 'preferredCountries')
      : formatSelectedValues(profileData, 'preferred_countries')
  }
  onChange={handleMultiChange}
  placeholder="Select preferred countries"
/>
<MultiCountryStateCitySelector
  key={`cities-${editModeActive}`}
labelPrefix="Preferred Locations (Country / State / City)"
  name="preferredCities"
  selectedValues={
    formatSelectedValues(formData, 'preferredCities').length
      ? formatSelectedValues(formData, 'preferredCities')
      : formatSelectedValues(profileData, 'preferred_cities')
  }
  onChange={handleMultiChange}
  placeholder="Select preferred cities"
/>

<MultiSelectCheckbox
  label="Preferred Professions"
  name="preferredProfessions"
  options={professionOptions}
  selectedValues={
    formatSelectedValues(formData, 'preferredProfessions').length
      ? formatSelectedValues(formData, 'preferredProfessions')
      : formatSelectedValues(profileData, 'preferred_professions')
  }
  onSearch={setProfessionInput}
  searchInput={professionInput}
  onChange={(name, values) => {
    handleMultiChange(name, values);
    setProfessionInput('');
  }}
  placeholder="Type to search profession (min 2 characters)"
  loading={professionLoading}
/>


<FullWidthHobbiesGrid
  label="Preferred Hobbies"
  fieldName="preferredHobbies"
  formData={{
    ...formData,
    preferredHobbies:
      formatSelectedValues(formData, "preferredHobbies").length
        ? formatSelectedValues(formData, "preferredHobbies")
        : formatSelectedValues(profileData, "preferred_hobbies"),
  }}
  handleChange={handleHobbyChange}
/>
        



      </div>
    </section>
  );
};

export default GeographicPreferences;
